import './style.css';

import React, { Fragment } from 'react';

export default function LayoutDefault({ children }: { children: React.ReactNode }) {
  return <Fragment>{children}</Fragment>;
}
